import React, { useEffect, useState, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Radio,
  Cascader,
  Tooltip,
  Spin,
  Slider,
  Typography,
  Row,
  Col,
  Checkbox,
  Space,
  Table,
  Collapse,
  Menu,
  Dropdown,
} from 'antd';
import cx from 'classnames';
import Icon, {
  InfoCircleFilled,
  LoadingOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import { ReactComponent as no_results_filled } from '../../../../assets/icons/no_results_filled.svg';
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import DeleteRecipeModal from '../../../../shared-components/DeleteRecipeModal';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';
import { validateRecipeNetworkAddress } from '../../../../shared-components/Validation/RecipeNetworkAddress';
import { validateRecipeNameServer } from '../../../../shared-components/Validation/RecipeNameServer';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import SpoofingResult from '../SpoofingExploreRecipe/ResultsTable';
import _ from 'lodash';
import {
  exportSpoofingToCSV,
  exportSpoofingToJSON,
} from '../../../../redux/actions/ioc';
import { BackToTopButton } from '../../../../shared-components/BackToTopButton';
import moment from 'moment-timezone';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

const { Panel } = Collapse;

function Spoofing(props) {
  mixpanel.track('Global Nav - Spoofing', { location: window.location.href });
  const {
    exploreRecipeSpoofing,
    loadMergeAPIRiskScores,
    loadMergeAPIASNDetails,
    loadUser,
    loadSources,
    createEmptySource,
    createFileSource,
    updateFileSource,
    addIOCJson,
    clearExploreDetails,
    loadScoreDetails,
    loadMergeAPIExploreRecipe,
    loadMergeAPIEnrichment,
    loadMergeAPIIPDetails,
    loadMergeAPIDomainDetails,
    loadMergeAPIExploreDetails,
    loadMergeAPIMergeDetails,
    loadMergeAPIExploreAnyIPDetails,
    loadMergeAPIExploreDensity,
    loadMergeAPIWhoisDetails,
    loadMergeAPIDomainInfraTags,
    loadIPEditableFeeds,
    loadDomainEditableFeeds,
    loadURLEditableFeeds,
    searchForTags,
    resetTagSearch,
    saveMonitoringQuery,
    loadResultFile,
    loadHistoryQueryResult,
    exportExploreResultToCSV,
    exportExploreResultToJSON,
    exportSpoofingToCSV,
    exportSpoofingToJSON,
    exportSingleIOC,
    resetEnrichment,
    loadMySubscriptionPlan,
    saveBreadCrumbs,
    queryNameInTXTRecipe,

    user,
    sources,
    exploreFilters,
    exploreSorting,
    status,
    scoreDetails,
    mergeAPIEnrichment,
    mergeAPIscoreDetails,
    exploreAPIscoreDetails: exploreAPIscoreDetails,
    mergeAPIData: mergeAPIData,
    exploreAPIANYIPscoreDetails: exploreAPIANYIPscoreDetails,
    exploreAPIANYIPJobID: exploreAPIANYIPJobID,
    exploreAPIDensityDetails: exploreAPIDensityDetails,
    exploreAPIDensityStatus: exploreAPIDensityStatus,
    exploreAPIwhoisDetails: exploreAPIwhoisDetails,
    infraTagStatus: infraTagStatus,
    domainInfraTags: domainInfraTags,
    whoisStatus: whoisStatus,
    IPEditableFeeds: IPEditableFeeds,
    IPEditableFeedsStatus: IPEditableFeedsStatus,
    DomainEditableFeeds: DomainEditableFeeds,
    DomainEditableFeedsStatus: DomainEditableFeedsStatus,
    URLEditableFeeds: URLEditableFeeds,
    URLEditableFeedsStatus: URLEditableFeedsStatus,
    foundTags: foundTags,
    searchStatus: searchStatus,
    riskScoreStatus: riskScoreStatus,
    exploreRiskScores: exploreRiskScores,
    exploreASNStatus: exploreASNStatus,
    exploreASNDetails: exploreASNDetails,
    mySubscriptionPlan: mySubscriptionPlan,
    mySubscriptionPlanStatus: mySubscriptionPlanStatus,
    breadcrumbs: breadcrumbs,
    loadBrandImpersonationRecipeResults,

    clearRecipe,
    unsetClearRecipe,
  } = props;
  const { Text, Title, Paragraph } = Typography;

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  // eslint-disable-next-line no-unused-vars
  const [networkFormStatus, setNetworkFormStatus] = useState('validating');
  // eslint-disable-next-line no-unused-vars
  const [additionalNetworksFormStatus] = useState('process');
  // eslint-disable-next-line no-unused-vars
  const [nameServerFormStatus, setNameServerFormStatus] = useState('error');
  // eslint-disable-next-line no-unused-vars
  const [ASNFormStatus, setASNFormStatus] = useState('process');

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const threatNameValue = Form.useWatch('threat_name', form);
  const regexValue = Form.useWatch('regex', form);
  const NSNameValue = Form.useWatch('nsname', form);
  const additionalNetworksValue = Form.useWatch('additional_networks', form);
  const ASNameValue = Form.useWatch('asname', form);
  const ASNumberValue = Form.useWatch('asnumber', form);
  const matchValue = Form.useWatch('match', form);
  const netValue = Form.useWatch('net', form);
  const ASNValue = Form.useWatch('asn', form);
  const firstSeenBeforeValue = Form.useWatch('first_seen_before', form);
  const firstSeenAfterValue = Form.useWatch('first_seen_after', form);
  const lastSeenBeforeValue = Form.useWatch('last_seen_before', form);
  const lastSeenAfterValue = Form.useWatch('last_seen_after', form);
  const sortValue = Form.useWatch('sort', form);

  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const [firstSeenFilterRangeValues, setFirstSeenFilterRangeValues] = useState([
    0,
    7,
  ]);
  const [lastSeenFilterRangeValues, setLastSeenFilterRangeValues] = useState([
    0,
    7,
  ]);
  const [ASdata, setASdata] = useState([]);
  const [preSelectASrowsNumber, setPreSelectASrowsNumber] = useState(0);
  const [autoSelectASrows, setAutoSelectASrows] = useState(false);
  const [searchedASstatus, setSearchedASstatus] = useState(false);
  const [selectedASrows, setSelectedASrows] = useState([]);
  const [AStableKey, setAStableKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const ClearFilters = (props) => <Icon component={no_results} {...props} />;
  const ClearFiltersFilled = (props) => (
    <Icon component={no_results_filled} {...props} />
  );

  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);

  const openAllCollapse = () => {
    setActiveCollapseKey(['1', '2']);
  };

  const toggleCollapse = (key) => {
    if (activeCollapseKey?.includes(key)) {
      setActiveCollapseKey(activeCollapseKey?.filter((k) => k !== key));
    } else {
      setActiveCollapseKey([...activeCollapseKey, key]);
    }
  };

  const recipeInitCollapse = () => {
    setActiveCollapseKey(['1']);
  };

  const searchActionCollapse = () => {
    setActiveCollapseKey(['2']);
  };

  function buttonDisableCondition(buttonType) {
    const validation = validateRecipeDomainName(threatNameValue, titleText);

    if (buttonType === 'autofill') {
      if (props.mySubscriptionPlan?.has_access_to_explore) {
        if (validation.valid) {
          return false;
        } else {
          return true;
        }
      } else return true;
    } else if (buttonType === 'addASN') {
      if (validation.valid) {
        return false;
      } else {
        return true;
      }
    }
  }

  function buttonTooltipText(buttonType) {
    const validation = validateRecipeDomainName(threatNameValue, titleText);

    if (buttonType === 'autofill') {
      if (validation.valid) {
        return 'Get all infrastructure that’s on a given domain.';
      } else {
        return 'Get all infrastructure that’s on a given domain. Enter a valid domain to enable Auto-fill.';
      }
    }

    if (buttonType === 'addASN') {
      if (validation.valid) {
        return '';
      } else {
        return 'Enter a valid domain to enable adding ASNs and AS Names.';
      }
    }
  }

  const DropdownMenu = () => {
    return (
      <Menu>
        {
          <>
            {((q?.get('recipeid') &&
              props?.exploreRecipeSpoofing?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSpoofing?.scope === 'ORGANISATION' &&
                props?.exploreRecipeSpoofing?.is_mine === true)) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('edit');
                  setIsModalVisible(true);
                }}
              >
                Edit Metadata
              </Menu.Item>
            )}

            {((q?.get('recipeid') &&
              props?.exploreRecipeSpoofing?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSpoofing?.scope === 'ORGANISATION')) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('saveAs');
                  setIsModalVisible(true);
                }}
              >
                Save As
              </Menu.Item>
            )}

            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_share_unshare ? (
                  ''
                ) : (
                  <>
                    Sharing option is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              {((q?.get('recipeid') &&
                props?.exploreRecipeSpoofing?.scope === 'USER') ||
                (q?.get('recipeid') &&
                  props?.exploreRecipeSpoofing?.scope === 'ORGANISATION' &&
                  props?.exploreRecipeSpoofing?.is_mine === true)) && (
                <Menu.Item onClick={() => changeScopeRecipe()}>
                  {props?.exploreRecipeSpoofing?.scope === 'ORGANISATION'
                    ? 'Unshare'
                    : 'Share'}
                </Menu.Item>
              )}
            </Tooltip>

            {((q?.get('recipeid') &&
              props?.exploreRecipeSpoofing?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSpoofing?.scope === 'ORGANISATION' &&
                props?.exploreRecipeSpoofing?.is_mine === true)) && (
              <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
                <span style={{ color: 'red' }}>Delete</span>
              </Menu.Item>
            )}
          </>
        }
      </Menu>
    );
  };

  function FormHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('1')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Form
        </Title>
      </div>
    );
  }

  function ResultsHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('2')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Results
        </Title>
      </div>
    );
  }

  const options = [
    {
      value: 'first_seen',
      label: 'First Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'last_seen',
      label: 'Last Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'query',
      label: 'Query',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'answer',
      label: 'Answer',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
  ];

  const titleText = q?.get('left_menu_name') || 'Brand Impersonation';

  const formRef = useRef(null);

  function resetForm() {
    form.resetFields();
    setFirstSeenFilterRangeValues([0, 7]);
    setLastSeenFilterRangeValues([0, 7]);
    recipeInitCollapse();
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    setSearchQuery('');
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeSpoofing(q?.get('recipeid'));
    }
    initASNtable();
  }

  const initASNtable = () => {
    if (q?.get('recipeid')) {
      setASdata([]);
      setPreSelectASrowsNumber(0);
      setAutoSelectASrows(false);
      setSearchedASstatus(false);
      setSelectedASrows([]);
      props.resetASNautofillStatus();
      //load specific recipe
      props.loadMergeAPIExploreRecipeSpoofing(q?.get('recipeid'));
    } else {
      setASdata([]);
      setPreSelectASrowsNumber(0);
      setAutoSelectASrows(false);
      setSearchedASstatus(false);
      setSelectedASrows([]);
      props.resetASNautofillStatus();
    }
  };

  function updateButtonDisabled() {
    if (
      exploreRecipeSpoofing?.domain === threatNameValue &&
      (exploreRecipeSpoofing?.regex ? exploreRecipeSpoofing?.regex : '') ===
        regexValue &&
      _.isEqual(
        exploreRecipeSpoofing?.name_servers?.map((n) => n.name),
        NSNameValue,
      ) &&
      _.isEqual(
        exploreRecipeSpoofing?.additional_networks
          ?.sort((a, b) => {
            if (a.is_main) return -1;
            if (b.is_main) return 1;
            return 0;
          })
          ?.map((n) => n.network),
        additionalNetworksValue,
      ) &&
      _.isEqual(
        exploreRecipeSpoofing?.as_records?.map((as) => as.number),
        selectedASrows?.map((as) => as.number),
      ) &&
      (exploreRecipeSpoofing?.is_name_server_in === true ? 'eq' : 'neq') ===
        matchValue &&
      (exploreRecipeSpoofing?.is_network_in === true ? 'in' : 'notin') ===
        netValue &&
      (exploreRecipeSpoofing?.is_asn_in === true ? 'in' : 'notin') ===
        ASNValue &&
      ((exploreRecipeSpoofing?.first_seen_before
        ? exploreRecipeSpoofing?.first_seen_before
        : 0) === firstSeenFilterRangeValues?.[0] ??
        0) &&
      ((exploreRecipeSpoofing?.first_seen_after
        ? exploreRecipeSpoofing?.first_seen_after
        : 7) === firstSeenFilterRangeValues?.[1] ??
        7) &&
      ((exploreRecipeSpoofing?.last_seen_after
        ? exploreRecipeSpoofing?.last_seen_after
        : 7) === lastSeenFilterRangeValues?.[1] ??
        7) &&
      ((exploreRecipeSpoofing?.last_seen_before
        ? exploreRecipeSpoofing?.last_seen_before
        : 0) === lastSeenFilterRangeValues?.[0] ??
        0) &&
      _.isEqual(
        exploreRecipeSpoofing?.sort_by
          ? [exploreRecipeSpoofing?.sort_by, exploreRecipeSpoofing?.order_by]
          : ['first_seen', 'desc'],
        sortValue,
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.resetASNautofillStatus();
    form.resetFields();
    recipeInitCollapse();
    initASNtable();
    dispatch(changeTitle(titleText, null));
    setSearchQuery('');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    props.resetASNautofillStatus();
    form.resetFields();
    recipeInitCollapse();
    setSaveModalType('saveNew');
    initASNtable();
    setSearchQuery('');
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (clearRecipe === true) {
      document.title = `${titleText} - Silent Push`;
      props.clearExploreDetails();
      props.saveBreadCrumbs(null);
      props.loadUser();
      props.loadMySubscriptionPlan();
      props.resetRecipeStatus();
      props.resetASNautofillStatus();
      form.resetFields();
      recipeInitCollapse();
      initASNtable();
      dispatch(changeTitle(titleText, null));
      setSearchQuery('');
      props.unsetClearRecipe();
    }
  }, [clearRecipe]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // form.resetFields();
    setFirstSeenFilterRangeValues([
      exploreRecipeSpoofing?.first_seen_before ?? 0,
      exploreRecipeSpoofing?.first_seen_after ?? 7,
    ]);
    setLastSeenFilterRangeValues([
      exploreRecipeSpoofing?.last_seen_before ?? 0,
      exploreRecipeSpoofing?.last_seen_after ?? 7,
    ]);
    dispatch(changeTitle(exploreRecipeSpoofing?.name ?? titleText, null));
    document.title = `${titleText} - Silent Push`;

    // }, [exploreRecipeSpoofing]); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    if (window.location.href.includes('/explore/brand-impersonation')) {
      if (
        exploreRecipeSpoofing?.uuid &&
        window.location.href.indexOf(
          '/explore/brand-impersonation?recipeid=' +
            exploreRecipeSpoofing?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/brand-impersonation?recipeid=' +
            exploreRecipeSpoofing?.uuid,
        );
        dispatch(highlightLeftMenu(exploreRecipeSpoofing?.uuid));
      }
      form.resetFields();
      recipeInitCollapse();
      form.setFieldsValue({
        threat_name: exploreRecipeSpoofing?.domain,
        regex: exploreRecipeSpoofing?.regex ? exploreRecipeSpoofing?.regex : '',
        nsname: exploreRecipeSpoofing?.name_servers?.map((n) => n.name),
        additional_networks: exploreRecipeSpoofing?.additional_networks
          ?.sort((a, b) => {
            if (a.is_main) return -1;
            if (b.is_main) return 1;
            return 0;
          })
          ?.map((n) => n.network),
        asname: exploreRecipeSpoofing?.as_names?.map((AS) => AS.name),
        asnumber: exploreRecipeSpoofing?.as_numbers?.map((AS) => AS.number),
        match: exploreRecipeSpoofing?.is_name_server_in === true ? 'eq' : 'neq',
        net: exploreRecipeSpoofing?.is_network_in === true ? 'in' : 'notin',
        asn: exploreRecipeSpoofing?.is_asn_in === true ? 'in' : 'notin',
        first_seen_before: exploreRecipeSpoofing?.first_seen_before
          ? exploreRecipeSpoofing?.first_seen_before
          : 0,
        first_seen_after: exploreRecipeSpoofing?.first_seen_after
          ? exploreRecipeSpoofing?.first_seen_after
          : 7,
        last_seen_before: exploreRecipeSpoofing?.last_seen_before
          ? exploreRecipeSpoofing?.last_seen_before
          : 0,
        last_seen_after: exploreRecipeSpoofing?.last_seen_after
          ? exploreRecipeSpoofing?.last_seen_after
          : 7,
        limit:
          exploreRecipeSpoofing?.limit === 100
            ? ''
            : exploreRecipeSpoofing?.limit,
        sort: exploreRecipeSpoofing?.sort_by
          ? [exploreRecipeSpoofing?.sort_by, exploreRecipeSpoofing?.order_by]
          : ['first_seen', 'desc'],
        is_last_24_hours: exploreRecipeSpoofing?.is_last_24_hours
          ? exploreRecipeSpoofing?.is_last_24_hours
          : false,
      });
      if (
        props.recipeStatusSpoofing === STATUS.LOADED &&
        exploreRecipeSpoofing?.name
      ) {
        document.title = `${exploreRecipeSpoofing?.name} - Silent Push`;
        if (exploreRecipeSpoofing?.as_records?.length > 0) {
          loadAStable();
        }
      }
    }
  }, [exploreRecipeSpoofing]);

  useEffect(() => {
    if (props.nameServerAutoFillStatus === STATUS.LOADED) {
      let networks = props?.nameServerAutoFillData?.response?.records
        ?.filter((record) => {
          if (record.type === 'A') {
            return record;
          }
        })
        ?.map((element) => element.answer)
        ?.slice(0, 15);

      let nameServers = props?.nameServerAutoFillData?.response?.records
        ?.filter((record) => {
          if (record.type === 'NS') {
            return record;
          }
        })
        ?.map((element) => element.answer)
        ?.slice(0, 15);

      form.setFieldsValue({
        additional_networks: networks,
        nsname: nameServers,
      });
    } else {
      form.setFieldsValue({
        additional_networks: [],
        nsname: [],
      });
    }
  }, [props.nameServerAutoFillStatus]);

  useEffect(() => {
    if (props.ASNAutoFillStatus === STATUS.LOADED) {
      const initialASdata = ASdata?.slice(0, 50)?.map((ASrow) => {
        return {
          ...ASrow,
          ...{ check_sort: preSelectASrowsNumber > 0 ? 1 : 0 },
        };
      });
      setASdata([...initialASdata, ...ASdata.slice(50)]);
      setSelectedASrows(preSelectASrowsNumber > 0 ? initialASdata : []);
    }
  }, [preSelectASrowsNumber]);

  useEffect(() => {
    if (props.ASNAutoFillStatus === STATUS.LOADED) {
      setAStableKey(AStableKey + 1);
    }
  }, [selectedASrows, ASdata]);

  useEffect(() => {
    if (props.ASNAutoFillStatus === STATUS.LOADED) {
      const _ASdata = props?.ASNAutoFillData?.response?.records?.map((AS) => {
        return {
          key: AS?.['asn'],
          number: AS?.['asn'],
          name: AS?.['asname'],
          asn_size: AS?.['asn_size'],
          domain_hosts_in_asn: AS?.['domain_hosts_in_asn'],
          check_sort: 0,
        };
      });
      let initialASdata = [];
      if (autoSelectASrows) setPreSelectASrowsNumber(50);
      if (exploreRecipeSpoofing?.as_records?.length > 0) {
        initialASdata = exploreRecipeSpoofing?.as_records?.map((ASrecord) => ({
          key: ASrecord?.number,
          number: ASrecord?.number,
          name: ASrecord?.name || `${ASrecord?.number}`,
          check_sort: 1,
          asn_size: 1,
          domain_hosts_in_asn: 1,
        }));
      } else if (exploreRecipeSpoofing?.as_numbers?.length > 0) {
        /***
         * @TODO: in the backend, ASnumber and ASname are 2 different models,
         * which makes difficult to reconstruct since we have to combine them in
         * the frontend, should be refactored in the backend into a single model
         * and then we can remove this mess
         */
        initialASdata = exploreRecipeSpoofing?.as_numbers?.map((ASnumber) => ({
          key: ASnumber?.number,
          number: ASnumber?.number,
          /***
           * here's the problem: AS names are unique by name in the
           * backend, i.e.: selecting 50 ASNs actually saves 48, we end up
           * with 50 ASnumbers but only 48 ASnames
           */
          name:
            exploreRecipeSpoofing?.as_names?.shift()?.name ||
            `${ASnumber?.number}`,
          check_sort: 1,
          asn_size: 1,
          domain_hosts_in_asn: 1,
        }));
      }
      setSelectedASrows(initialASdata);
      setASdata(
        _ASdata
          ?.filter(
            (a) => !initialASdata?.find((_a) => a?.['key'] === _a?.['key']),
          )
          //To work around the recipes without domain, only regex
          ?.concat(initialASdata) ?? initialASdata,
      );
    }
  }, [props.ASNAutoFillStatus]);

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };
  const loadAStable = () => {
    setAutoSelectASrows(false);
    setPreSelectASrowsNumber(0);
    setSelectedASrows([]);
    form
      .validateFields()
      .then((values) => {
        const domain =
          values?.threat_name
            ?.replaceAll('[', '')
            ?.replaceAll(']', '')
            ?.trim()
            ?.replaceAll(' ', '')
            ?.replaceAll('./', '.') ?? exploreRecipeSpoofing.domain;
        //This is not guaranteed, there are recipes without domain, only regex
        props.loadASNAutoFill({
          path:
            'padns/lookup/domain/asns/' +
            domain +
            '?result_format=full&is_voluntary=0',
        });
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  function autoFillData() {
    setAutoSelectASrows(true);

    const domain =
      form
        .getFieldValue('threat_name')
        ?.replaceAll('[', '')
        ?.replaceAll(']', '')
        ?.trim()
        ?.replaceAll(' ', '')
        ?.replaceAll('./', '.') ?? exploreRecipeSpoofing.domain;
    props.loadNameServerAutoFill({
      path:
        'padns/snapshot/domain/' +
        domain +
        '?result_format=full&is_voluntary=0',
    });
    props.loadASNAutoFill({
      path:
        'padns/lookup/domain/asns/' +
        domain +
        '?result_format=full&is_voluntary=0',
    });

    form.validateFields();
  }

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeSpoofing({
      scope:
        props?.exploreRecipeSpoofing?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeSpoofing?.uuid,
    });
    incrementUIRequestsCounter();
  }

  const handleFirstSeenRangeChange = (range) => {
    setFirstSeenFilterRangeValues(range);
    form.setFieldsValue({
      first_seen_before: range?.[0],
      first_seen_after: range?.[1],
    });
  };

  const handleLastSeenRangeChange = (range) => {
    setLastSeenFilterRangeValues(range);
    form.setFieldsValue({
      last_seen_before: range?.[0],
      last_seen_after: range?.[1],
    });
  };

  const firstSeenMarks = {
    0: {
      label: <Text style={{ color: 'white' }}>0 day</Text>,
    },
    1: {
      label: <Text style={{ color: 'white' }}>1 day</Text>,
    },
    2: {
      label: <Text style={{ color: 'white' }}>2 days</Text>,
    },
    3: {
      label: <Text style={{ color: 'white' }}>3 days</Text>,
    },
    4: {
      label: <Text style={{ color: 'white' }}>4 days</Text>,
    },
    5: {
      label: <Text style={{ color: 'white' }}>5 days</Text>,
    },
    6: {
      label: <Text style={{ color: 'white' }}>6 days</Text>,
    },
    7: {
      label: <Text style={{ color: 'white' }}>7 days</Text>,
    },
    8: {
      label: <Text style={{ color: 'white' }}>14 d.</Text>,
    },
    9: {
      label: <Text style={{ color: 'white' }}>30 d.</Text>,
    },
    10: {
      label: <Text style={{ color: 'white' }}>90 d.</Text>,
    },
    11: {
      label: <Text style={{ color: 'white' }}>180 d.</Text>,
    },
    12: {
      label: (
        <Text style={{ color: 'white', whiteSpace: 'nowrap' }}>365 d.</Text>
      ),
    },
  };

  const lastSeenMarks = {
    0: {
      label: <Text style={{ color: 'white' }}>0 day</Text>,
    },
    1: {
      label: <Text style={{ color: 'white' }}>1 day</Text>,
    },
    2: {
      label: <Text style={{ color: 'white' }}>2 days</Text>,
    },
    3: {
      label: <Text style={{ color: 'white' }}>3 days</Text>,
    },
    4: {
      label: <Text style={{ color: 'white' }}>4 days</Text>,
    },
    5: {
      label: <Text style={{ color: 'white' }}>5 days</Text>,
    },
    6: {
      label: <Text style={{ color: 'white' }}>6 days</Text>,
    },
    7: {
      label: (
        <Text style={{ color: 'white', whiteSpace: 'nowrap' }}>7 days</Text>
      ),
    },
  };

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery ? nameOfNewQuery : exploreRecipeSpoofing?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeSpoofing?.description,
      };
    } else {
      return {
        name: nameOfNewQuery ? nameOfNewQuery : exploreRecipeSpoofing?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeSpoofing?.description,
        domain: values?.threat_name
          ?.replaceAll('[', '')
          ?.replaceAll(']', '')
          ?.trim()
          ?.replaceAll(' ', '')
          ?.replaceAll('./', '.'),
        regex: values?.regex ? values?.regex : '',
        name_servers: values?.nsname
          ? values.nsname?.map((n) => ({ name: n }))
          : [],
        as_records:
          selectedASrows.length > 0
            ? selectedASrows.map((AS) => ({
                number: AS.number,
                name: AS.name,
              }))
            : [],
        is_asn_in: values?.asn === 'in' ? true : false,
        is_network_in: values?.net === 'in' ? true : false,
        is_name_server_in: values?.match === 'eq' ? true : false,
        additional_networks: values?.additional_networks
          ? values.additional_networks.map((n, i) => ({
              is_main: i === 0,
              network: n,
            }))
          : [],
        first_seen_after: firstSeenFilterRangeValues[1] ?? 7,
        first_seen_before: firstSeenFilterRangeValues[0] ?? 0,
        last_seen_after: lastSeenFilterRangeValues[1] ?? 7,
        last_seen_before: lastSeenFilterRangeValues[0] ?? 0,
        limit: values?.limit ? values?.limit : 100,
        order_by: values?.sort?.length > 0 ? values?.sort[1] : null,
        sort_by: values?.sort?.length > 0 ? values?.sort[0] : null,
        first_seen_relative: null,
        last_seen_relative: null,
        is_last_24_hours: values?.is_last_24_hours ? true : false,
        uuid: q?.get('recipeid'),
      };
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeSpoofing(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeSpoofing(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'spoofing-recipes',
            q?.get('recipeid'),
          );
        }
        incrementUIRequestsCounter();
      })
      .catch((errorInfo) => {
        // console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  const handleDeleteRecipe = () => {
    props.deleteMergeAPIExploreRecipeSpoofing(q?.get('recipeid'));
    props.resetRecipeStatus();
    props.clearExploreDetails();
    props.history.push(
      '/explore/brand-impersonation/?left_menu_name=Brand%20Impersonation',
    );
    setIsDeleteModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  function convertFilterValueToDay(filterValue) {
    let days = filterValue;
    switch (filterValue) {
      case 8:
        days = 14;
        break;
      case 9:
        days = 30;
        break;
      case 10:
        days = 90;
        break;
      case 11:
        days = 180;
        break;
      case 12:
        days = 365;
        break;
      default:
        days = filterValue;
        break;
    }
    /*
    We need to use absolute timestamps since some domains like
    'facebook' have a high rate of new records every second.
    !!!DON'T USE RELATIVE TIMESTAMPS!!!
     */
    return moment()
      .utc()
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)
      .subtract(days, 'days')
      .unix();
  }

  const handleASsearch = (selectedKeys, confirm, dataIndex) => {
    confirm({ closeDropdown: false });
    setSearchedASstatus(true);
  };

  const handleASsearchReset = (
    clearFilters,
    selectedKeys,
    confirm,
    dataIndex,
  ) => {
    clearFilters();
    handleASsearch(selectedKeys, confirm, dataIndex);
    setSearchedASstatus(false);
  };

  const resetAStableFilters = () => {
    setAStableKey(AStableKey + 1);
    setSearchedASstatus(false);
  };

  const getASfilterProps = (ASfield) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      visible,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          placeholder={`Search ${ASfield}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(
              e?.target?.value.toLowerCase()
                ? [e?.target?.value.toLowerCase()]
                : [],
            )
          }
          onPressEnter={() => handleASsearch(selectedKeys, confirm, ASfield)}
          style={{ marginBottom: 8, display: 'block' }}
          maxLength={100}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleASsearch(selectedKeys, confirm, ASfield)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() =>
              clearFilters &&
              handleASsearchReset(clearFilters, selectedKeys, confirm, ASfield)
            }
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: true });
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (searchString, ASrow) =>
      ASrow[ASfield]?.toString()?.toLowerCase()?.includes(searchString),
  });

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_brand_impersonation_recipe ? (
        props.recipeStatusSpoofing !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div
                  data-cy="brandImpersonationRecipeQueryFormChip"
                  className={cx(threat_detail_styles['type-chip'])}
                >
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph
                    data-cy="brandImpersonationRecipeQueryFormDescription"
                    className="m-0"
                  >
                    {exploreRecipeSpoofing?.description
                      ? exploreRecipeSpoofing.description
                      : 'Check for Typosquatting of company domains or supply chain domains. Exclude company infrastructure from your search using our form.'}{' '}
                    <span className={styles.header_former_recipe_appendix_text}>
                      (former Typosquatting recipe)
                    </span>
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/typosquatting',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  <Tooltip
                    title={
                      updateButtonDisabled() ? 'Form values unchanged.' : ''
                    }
                  >
                    <Button
                      disabled={updateButtonDisabled()}
                      role={'button1'}
                      onClick={() => {
                        if (
                          saveModalType === 'saveNew' &&
                          !q?.get('recipeid')
                        ) {
                          form
                            .validateFields()
                            .then((values) => {
                              setNameOfNewQuery('');
                              setDescriptionOfNewQuery('');
                              setSaveModalType('saveNew');
                              setIsModalVisible(true);
                            })
                            .catch((errorInfo) => {});
                        } else {
                          handleOk('edit');
                        }
                      }}
                    >
                      {q?.get('recipeid') ? 'Update' : 'Save'}
                    </Button>
                  </Tooltip>
                  {((q?.get('recipeid') &&
                    props?.exploreRecipeSpoofing?.scope === 'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeSpoofing?.scope ===
                        'ORGANISATION')) && (
                    <Dropdown trigger={['click']} overlay={DropdownMenu({})}>
                      <MoreOutlined className={styles.dropdown_icon} />
                    </Dropdown>
                  )}
                </div>
              </Col>
            </Row>

            <BackToTopButton />

            <div className={cx('collapse_row_recipe')}>
              {/* <Col xs={24}> */}
              <Collapse
                defaultActiveKey={['1']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={FormHeader()} key="1">
                  {/* <Row gutter={24}> */}
                  {/* <Col xs={24} lg={12}> */}

                  <Form
                    className={styles.form}
                    ref={formRef}
                    form={form}
                    name="spoofing"
                    initialValues={{
                      threat_name: exploreRecipeSpoofing?.domain,
                      regex: exploreRecipeSpoofing?.regex
                        ? exploreRecipeSpoofing?.regex
                        : '',
                      nsname: exploreRecipeSpoofing?.name_servers?.map(
                        (n) => n.name,
                      ),
                      additional_networks: exploreRecipeSpoofing?.additional_networks
                        ?.sort((a, b) => {
                          if (a.is_main) return -1;
                          if (b.is_main) return 1;
                          return 0;
                        })
                        ?.map((n) => n.network),
                      asname: exploreRecipeSpoofing?.as_names?.map(
                        (AS) => AS.name,
                      ),
                      asnumber: exploreRecipeSpoofing?.as_numbers?.map(
                        (AS) => AS.number,
                      ),
                      match:
                        exploreRecipeSpoofing?.is_name_server_in === true
                          ? 'eq'
                          : 'neq',
                      net:
                        exploreRecipeSpoofing?.is_network_in === true
                          ? 'in'
                          : 'notin',
                      asn:
                        exploreRecipeSpoofing?.is_asn_in === true
                          ? 'in'
                          : 'notin',
                      first_seen_before: exploreRecipeSpoofing?.first_seen_before
                        ? exploreRecipeSpoofing?.first_seen_before
                        : 0,
                      first_seen_after: exploreRecipeSpoofing?.first_seen_after
                        ? exploreRecipeSpoofing?.first_seen_after
                        : 7,
                      last_seen_before: exploreRecipeSpoofing?.last_seen_before
                        ? exploreRecipeSpoofing?.last_seen_before
                        : 0,
                      last_seen_after: exploreRecipeSpoofing?.last_seen_after
                        ? exploreRecipeSpoofing?.last_seen_after
                        : 7,
                      limit:
                        exploreRecipeSpoofing?.limit === 100
                          ? ''
                          : exploreRecipeSpoofing?.limit,
                      sort: exploreRecipeSpoofing?.sort_by
                        ? [
                            exploreRecipeSpoofing?.sort_by,
                            exploreRecipeSpoofing?.order_by,
                          ]
                        : ['first_seen', 'desc'],
                      is_last_24_hours: exploreRecipeSpoofing?.is_last_24_hours
                        ? exploreRecipeSpoofing?.is_last_24_hours
                        : false,
                    }}
                    onFinish={(values) => {
                      props.saveBreadCrumbs(null);

                      let mainNetwork;
                      let subnetMask;
                      let additionalNetworks;
                      if (values.additional_networks) {
                        additionalNetworks = [...values.additional_networks];
                      }
                      if (additionalNetworks && additionalNetworks.length > 0) {
                        mainNetwork = additionalNetworks;
                        if (mainNetwork?.includes('/')) {
                          const networkParts = mainNetwork.split('/');
                          mainNetwork = networkParts[0];
                          subnetMask = networkParts[1];
                        }
                      }

                      //                props.history.push(
                      setSearchQuery(
                        `/explore-result?name=${
                          values.regex
                            ? values.regex
                            : values.threat_name
                                ?.replaceAll('[', '')
                                ?.replaceAll(']', '')
                                ?.trim()
                                ?.replaceAll(' ', '')
                                ?.replaceAll('./', '.')
                        }&qanswer=_&queryType=typosquat&visualizationType=Brand Impersonation&type=` +
                          (values.type ? values.type : 'A') +
                          (values.limit ? `&limit=${values.limit}` : '') +
                          (values?.sort?.length > 0
                            ? `&sort_by=${values?.sort[0]}&order_by=${values?.sort[1]}`
                            : '') +
                          (values.match ? `&match=${values.match}` : '') +
                          (subnetMask ? `&netmask=${subnetMask}` : '') +
                          (values.nsname
                            ? `&nsname=${values?.nsname
                                ?.filter((n) => n !== ' ')
                                ?.map((n) => `${n.trim()}`)
                                .join(',')}`
                            : '') +
                          (values.asn ? `&asn=${values.asn.trim()}` : '') +
                          (selectedASrows.length > 0
                            ? '&asnum=' +
                              selectedASrows?.map((AS) => AS.number).join(',')
                            : '') +
                          (values.net ? `&net=${values.net}` : '') +
                          (additionalNetworks &&
                          additionalNetworks.filter((n) => n !== ' ').length > 0
                            ? `&additional_networks=${additionalNetworks
                                ?.filter((n) => n !== ' ')
                                ?.map((n) => `${n.trim()}`)
                                .join(',')}`
                            : '') +
                          `&first_seen_before=${convertFilterValueToDay(
                            firstSeenFilterRangeValues[0],
                          )}` +
                          `&first_seen_after=${convertFilterValueToDay(
                            firstSeenFilterRangeValues[1],
                          )}` +
                          `&last_seen_before=${convertFilterValueToDay(
                            lastSeenFilterRangeValues[0],
                          )}` +
                          `&last_seen_after=${convertFilterValueToDay(
                            lastSeenFilterRangeValues[1],
                          )}` +
                          (values.threat_name
                            ? `&autospoof=${values.threat_name
                                ?.replaceAll('[', '')
                                ?.replaceAll(']', '')
                                ?.trim()
                                ?.replaceAll(' ', '')
                                ?.replaceAll('./', '.')}`
                            : '') +
                          (values.regex ? `&regex=${values.regex}` : '') +
                          '&recipe=/explore/brand-impersonation' +
                          ((q?.get('recipeid')
                            ? `?recipeid=${q?.get('recipeid')}`
                            : '') ?? '') +
                          '&backLink=' +
                          encodeURIComponent(window.location.pathname) +
                          encodeURIComponent(window.location.search),
                      );

                      searchActionCollapse();
                      setTimeout(() => {
                        window.scrollTo(0, 0);
                      }, '10');
                    }}
                  >
                    <Row gutter={36} className="mb-1">
                      <Col xs={24}>
                        <Title level={5}>
                          Domain or Regex{' '}
                          <Text className={styles.requiredIndicator}>*</Text>{' '}
                          <Tooltip
                            placement="top"
                            title="Enter the domain or regex you want to search for. At least one field is required. If both fields are filled out regex will overwrite the domain."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="brandImpersonationRecipeQueryFormDomainNameLabel">
                          Domain Name{' '}
                          <Tooltip
                            placement="top"
                            title="Enter the domain you’d like to search for. Wildcards are not supported."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>

                        <Form.Item
                          className="m-0"
                          name="threat_name"
                          dependencies={['regex']}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                if (regexValue) {
                                  return Promise.resolve();
                                }

                                const validation = validateRecipeDomainName(
                                  fieldValue,
                                  titleText,
                                );

                                if (validation.valid) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(validation?.message);
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            data-cy="brandImpersonationRecipeQueryFormDomainNameInput"
                            maxLength={255}
                            placeholder="Enter Domain Name"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="brandImpersonationRecipeQueryFormRegexLabel">
                          Regex{' '}
                          <Tooltip
                            placement="top"
                            title="Enter a regex to apply to your search."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>

                        <Form.Item
                          className="m-0"
                          name="regex"
                          dependencies={['threat_name']}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(event, value) {
                                if (!regexValue && !threatNameValue) {
                                  return Promise.reject(
                                    'Please enter either a valid domain name or regex!',
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input
                            data-cy="brandImpersonationRecipeQueryFormRegexInput"
                            maxLength={100}
                            placeholder="Enter a regex"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        {props.nameServerAutoFillStatus === STATUS.LOADING ||
                        props.ASNAutoFillStatus === STATUS.LOADING ? (
                          <Spin
                            indicator={
                              <LoadingOutlined
                                style={{ fontSize: '24px', marginRight: '8px' }}
                              />
                            }
                          />
                        ) : (
                          <Tooltip
                            title={
                              props.mySubscriptionPlan
                                ?.has_access_to_explore ? (
                                buttonTooltipText('autofill')
                              ) : (
                                <>
                                  This option is not part of this subscription
                                  plan. To upgrade your subscription contact us
                                  at{' '}
                                  <a
                                    target="_blank"
                                    href="mailto:sales@silentpush.com"
                                  >
                                    sales@silentpush.com
                                  </a>
                                  .
                                </>
                              )
                            }
                          >
                            <Button
                              className="mt-05 mb-1"
                              disabled={buttonDisableCondition('autofill')}
                              onClick={() => autoFillData()}
                            >
                              Auto-fill Data
                            </Button>
                          </Tooltip>
                        )}
                      </Col>
                    </Row>

                    <Row gutter={36}>
                      <Col xs={24} lg={12}>
                        <div className={styles.title_flex}>
                          <Title level={5}>
                            Network{' '}
                            <Tooltip
                              placement="top"
                              title="Use the auto-fill button or enter a network (IP or subnet) you’d like to exclude or include from your search."
                            >
                              <InfoCircleFilled />
                            </Tooltip>
                          </Title>

                          <Form.Item
                            className={styles.item}
                            name="net"
                            rules={[
                              {
                                required: false,
                                message: 'Please input the type!',
                              },
                            ]}
                          >
                            <Radio.Group
                              data-cy="brandImpersonationRecipeQueryFormNetworkAddressIncludeExcludeButton"
                              defaultValue="notin"
                            >
                              <Radio.Button value="in">Include</Radio.Button>
                              <Radio.Button value="notin">Exclude</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </div>

                        <Text data-cy="brandImpersonationRecipeQueryFormNetworkAddressLabel">
                          Network address{' '}
                          <Tooltip
                            placement="top"
                            title="Use the auto-fill button or enter a network (IP or subnet) you’d like to exclude or include from your search."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>
                        <Form.Item
                          name="additional_networks"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                if (fieldValue?.length > 0) {
                                  const validation = validateRecipeNetworkAddress(
                                    fieldValue,
                                  );

                                  if (validation.valid) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(validation?.message);
                                  }
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            }),
                          ]}
                        >
                          <Select
                            data-cy="brandImpersonationRecipeQueryFormNetworkAddressField"
                            placeholder="Enter a network address"
                            onChange={(value) => {
                              if (value.length > 15) value.pop();
                              setNetworkFormStatus('finish');
                            }}
                            mode="tags"
                            maxTagCount={50}
                            notFoundContent={null}
                            dropdownStyle={{ display: 'none' }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <div className={styles.title_flex}>
                          <Title level={5}>
                            Name Server{' '}
                            <Tooltip
                              placement="top"
                              title="Use the auto-fill button or specify nameservers that are either used or not used by your infrastructure (wildcards are allowed)."
                            >
                              <InfoCircleFilled />
                            </Tooltip>
                          </Title>

                          <Form.Item
                            className={styles.item}
                            name="match"
                            rules={[
                              {
                                required: false,
                                message: 'Please input the type!',
                              },
                            ]}
                          >
                            <Radio.Group
                              data-cy="brandImpersonationRecipeQueryFormNameServerEqualNotEqualButton"
                              defaultValue="neq"
                            >
                              <Radio.Button value="eq">Equal</Radio.Button>
                              <Radio.Button value="neq">Not Equal</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </div>

                        <Text data-cy="brandImpersonationRecipeQueryFormNameServerNameLabel">
                          Name Server Name{' '}
                          <Tooltip
                            placement="top"
                            title="Use the auto-fill button or specify nameservers that are either used or not used by your infrastructure (wildcards are allowed). Add up to 5 nameservers, separated by a character return."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>
                        <Form.Item
                          name="nsname"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                if (fieldValue?.length > 0) {
                                  const validation = validateRecipeNameServer(
                                    fieldValue,
                                  );

                                  if (validation.valid) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(validation?.message);
                                  }
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            }),
                          ]}
                        >
                          <Select
                            data-cy="brandImpersonationRecipeQueryFormNameServerNameField"
                            placeholder="Enter nameserver name"
                            onChange={(value) => {
                              if (value.length === 0) {
                                setNameServerFormStatus('error');
                                return;
                              }
                              if (value.length > 15) value.pop();
                              setNameServerFormStatus('finish');
                            }}
                            mode="tags"
                            maxTagCount={50}
                            notFoundContent={null}
                            dropdownStyle={{ display: 'none' }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[36, 24]}>
                      <Col xs={24}>
                        <div className={styles.title_flex}>
                          <Title level={5}>ASN - AS Name</Title>

                          <Form.Item
                            className={styles.item}
                            name="asn"
                            rules={[
                              {
                                required: false,
                                message: 'Please input the type!',
                              },
                            ]}
                          >
                            <Radio.Group
                              data-cy="brandImpersonationRecipeQueryFormNameServerIncludeExcludeButton"
                              defaultValue="notin"
                            >
                              <Radio.Button value="in">Include</Radio.Button>
                              <Radio.Button value="notin">Exclude</Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                        <label>
                          Choose up to 50 ASN and AS Name to exclude/include in
                          search. If you choose to exclude an ASN, domains
                          hosted in that ASN will be excluded from the results.
                          If you choose to include ASNs, only domains hosted on
                          those ASNs will be included in the results.
                        </label>
                      </Col>

                      {props.ASNAutoFillStatus == STATUS.LOADED ? (
                        <Col xs={24}>
                          <Form.Item
                            name={'AStable'}
                            validateStatus={
                              selectedASrows.length > 50 ? 'error' : 'success'
                            }
                            rules={[
                              ({ _ }) => ({
                                validator(_, value) {
                                  if (selectedASrows.length > 50) {
                                    return Promise.reject(
                                      new Error('Limit of 50 ASNs reached'),
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              }),
                            ]}
                          >
                            <Table
                              data-cy="brandImpersonationRecipeQueryFormASNTable"
                              key={AStableKey} //to force table re-render when reset filters
                              columns={[
                                {
                                  // workaround to move the checked rows to the top of the table
                                  title: (
                                    <Tooltip title={'Clear filters'}>
                                      <Button
                                        type={'link'}
                                        size={'small'}
                                        icon={
                                          searchedASstatus ? (
                                            <ClearFiltersFilled />
                                          ) : (
                                            <ClearFilters />
                                          )
                                        }
                                        onClick={() => resetAStableFilters()}
                                      />
                                    </Tooltip>
                                  ),
                                  dataIndex: 'check_sort',
                                  sorter: (a, b) => {
                                    return a.check_sort - b.check_sort;
                                  },
                                  defaultSortOrder: 'descend',
                                  showSorterTooltip: false,
                                  width: 35,
                                  render: (_) => null,
                                },
                                {
                                  title: (
                                    <ColumnTitle
                                      columnName="AS Number"
                                      tooltipText={
                                        'List of ASN that are currently hosting this domain’s infrastructure'
                                      }
                                    />
                                  ),
                                  dataIndex: 'number',
                                  ...getASfilterProps('number'),
                                },
                                {
                                  title: (
                                    <ColumnTitle
                                      columnName="AS Name"
                                      tooltipText={
                                        'List of AS Names that are currently hosting this domain’s infrastructure'
                                      }
                                    />
                                  ),
                                  dataIndex: 'name',
                                  ...getASfilterProps('name'),
                                  render: (name) => {
                                    if (name.length > 60) {
                                      return (
                                        <Tooltip title={name}>
                                          {name.slice(0, 60)}...
                                        </Tooltip>
                                      );
                                    } else {
                                      return name;
                                    }
                                  },
                                },
                                {
                                  title: (
                                    <ColumnTitle
                                      columnName="ASN Size"
                                      tooltipText={
                                        'Total allocated capacity for this ASN'
                                      }
                                    />
                                  ),
                                  dataIndex: 'asn_size',
                                },
                                {
                                  title: (
                                    <ColumnTitle
                                      columnName="Domains Hosts in ASN"
                                      tooltipText={
                                        'Number of IPs hosting this domain’s infrastructure that are currently on this ASN'
                                      }
                                    />
                                  ),
                                  dataIndex: 'domain_hosts_in_asn',
                                },
                              ]}
                              dataSource={ASdata}
                              rowSelection={{
                                type: 'checkbox',
                                selectedRowKeys: selectedASrows?.map(
                                  (a) => a.key,
                                ),
                                onSelect: (
                                  ASrow,
                                  selected,
                                  _selectedRows,
                                  nativeEevent,
                                ) => {
                                  form.validateFields(['AStable']);
                                  if (selected) {
                                    if (selectedASrows.length >= 50) {
                                      return false;
                                    }
                                    ASrow.check_sort = 1;
                                    setSelectedASrows([
                                      ...selectedASrows,
                                      ASrow,
                                    ]);
                                  } else {
                                    ASrow.check_sort = 0;
                                    selectedASrows.splice(
                                      selectedASrows?.findIndex(
                                        (a) => a.key == ASrow.key,
                                      ),
                                      1,
                                    );
                                    setSelectedASrows([...selectedASrows]);
                                  }
                                  return selected;
                                },
                                // workaround to replace the default "select all" widget
                                columnTitle: (
                                  <Tooltip
                                    title={'Select/unselect up to 50 ASNs'}
                                  >
                                    <Checkbox
                                      onChange={(e) => {
                                        form.validateFields(['AStable']);
                                        setPreSelectASrowsNumber(
                                          e?.target?.checked ? 50 : 0,
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                ),
                              }}
                              loading={
                                props.ASNAutoFillStatus === STATUS.LOADING
                              }
                              pagination={false}
                              scroll={{ y: '300px' }}
                              size={'small'}
                              footer={() => (
                                <Text
                                  style={{
                                    display: 'block',
                                    textAlign: 'right',
                                  }}
                                >
                                  {selectedASrows.length}/50 max allowed
                                </Text>
                              )}
                            />
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col xs={24} gutter={[24, 24]}>
                          <Tooltip title={buttonTooltipText('addASN')}>
                            <Button
                              onClick={loadAStable}
                              loading={
                                props.ASNAutoFillStatus === STATUS.LOADING
                              }
                              disabled={buttonDisableCondition('addASN')}
                            >
                              Add ASN - AS Name
                            </Button>
                          </Tooltip>
                        </Col>
                      )}

                      <Col xs={24} lg={12}>
                        <Title
                          data-cy="brandImpersonationRecipeQueryFormFirstSeenLabel"
                          level={5}
                        >
                          First Seen{' '}
                          <Tooltip
                            placement="top"
                            title="Default time frame when the record(s) was first seen is last 7 days. Change the time frame for older results."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>

                        <Form.Item
                          className={styles.hidden}
                          name="first_seen_after"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the netmask!',
                            },
                          ]}
                        ></Form.Item>

                        <Text data-cy="brandImpersonationRecipeQueryFormFirstSeenAfterLabel">
                          First Seen After
                        </Text>
                        <Text
                          data-cy="brandImpersonationRecipeQueryFormFirstSeenBeforeLabel"
                          className={styles.float}
                        >
                          First Seen Before
                        </Text>
                        <div
                          data-cy="brandImpersonationRecipeQueryFormFirstSeenSlider"
                          className={styles.slider_container}
                        >
                          <Slider
                            className={styles.slider}
                            range
                            reverse
                            defaultValue={[0, 7]}
                            value={firstSeenFilterRangeValues}
                            marks={firstSeenMarks}
                            included
                            onChange={handleFirstSeenRangeChange}
                            min={0}
                            max={12}
                          />
                        </div>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Title
                          data-cy="brandImpersonationRecipeQueryFormLastSeenLabel"
                          level={5}
                        >
                          Last Seen{' '}
                          <Tooltip
                            placement="top"
                            title="Default time frame when the record(s) was last seen is last 7 days."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>

                        <Text data-cy="brandImpersonationRecipeQueryFormLastSeenAfterLabel">
                          Last Seen After
                        </Text>
                        <Text
                          data-cy="brandImpersonationRecipeQueryFormLastSeenBeforeLabel"
                          className={styles.float}
                        >
                          Last Seen Before
                        </Text>
                        <div
                          data-cy="brandImpersonationRecipeQueryFormLastSeenSlider"
                          className={styles.slider_container}
                        >
                          <Slider
                            className={styles.slider}
                            range
                            reverse
                            defaultValue={[0, 7]}
                            value={lastSeenFilterRangeValues}
                            marks={lastSeenMarks}
                            included
                            onChange={handleLastSeenRangeChange}
                            min={0}
                            max={7}
                          />
                        </div>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Title level={5}>Sorting</Title>

                        <Text data-cy="brandImpersonationRecipeQueryFormSortingLabel">
                          Sort/Order
                        </Text>
                        <Form.Item name="sort">
                          <Cascader
                            data-cy="brandImpersonationRecipeQueryFormSortingDropdown"
                            options={options}
                            placeholder="Sort/Order"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div className={styles.bottom_actions}>
                      <div className="me-1">
                        <Form.Item>
                          <Tooltip
                            title={
                              props.mySubscriptionPlan
                                ?.has_access_to_explore ? (
                                ''
                              ) : (
                                <>
                                  This option is not part of this subscription
                                  plan. To upgrade your subscription contact us
                                  at{' '}
                                  <a
                                    target="_blank"
                                    href="mailto:sales@silentpush.com"
                                  >
                                    sales@silentpush.com
                                  </a>
                                  .
                                </>
                              )
                            }
                          >
                            <Button
                              disabled={
                                !props.mySubscriptionPlan?.has_access_to_explore
                              }
                              role={'button2'}
                              type="primary"
                              htmlType="submit"
                            >
                              Search
                            </Button>
                          </Tooltip>
                        </Form.Item>
                      </div>

                      <div>
                        <Button type="text" onClick={() => resetForm()}>
                          Reset
                        </Button>
                      </div>
                    </div>
                  </Form>
                  {/* </Col> */}
                  {/* </Row> */}
                </Panel>
              </Collapse>
              {/* </Col> */}
            </div>

            <div className={cx('collapse_row_recipe')}>
              {/* <Col xs={24}> */}
              <Collapse
                defaultActiveKey={['2']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={ResultsHeader()} key="2">
                  {/* <Row gutter={24}> */}
                  {/* <Col xs={24} lg={12}> */}
                  <div>
                    {searchQuery ? (
                      <SpoofingResult
                        searchQuery={searchQuery}
                        mySubscriptionPlanStatus={
                          props.mySubscriptionPlanStatus
                        }
                        mySubscriptionPlan={props.mySubscriptionPlan}
                        loadMergeAPIRiskScores={loadMergeAPIRiskScores}
                        loadMergeAPIASNDetails={loadMergeAPIASNDetails}
                        loadUser={loadUser}
                        loadSources={loadSources}
                        createEmptySource={createEmptySource}
                        createFileSource={createFileSource}
                        updateFileSource={updateFileSource}
                        addIOCJson={addIOCJson}
                        clearExploreDetails={clearExploreDetails}
                        loadScoreDetails={loadScoreDetails}
                        loadMergeAPIExploreRecipe={loadMergeAPIExploreRecipe}
                        loadMergeAPIEnrichment={loadMergeAPIEnrichment}
                        loadMergeAPIIPDetails={loadMergeAPIIPDetails}
                        loadMergeAPIDomainDetails={loadMergeAPIDomainDetails}
                        loadMergeAPIExploreDetails={loadMergeAPIExploreDetails}
                        loadMergeAPIMergeDetails={loadMergeAPIMergeDetails}
                        loadMergeAPIExploreAnyIPDetails={
                          loadMergeAPIExploreAnyIPDetails
                        }
                        loadMergeAPIExploreDensity={loadMergeAPIExploreDensity}
                        loadMergeAPIWhoisDetails={loadMergeAPIWhoisDetails}
                        loadMergeAPIDomainInfraTags={
                          loadMergeAPIDomainInfraTags
                        }
                        loadIPEditableFeeds={loadIPEditableFeeds}
                        loadDomainEditableFeeds={loadDomainEditableFeeds}
                        loadURLEditableFeeds={loadURLEditableFeeds}
                        searchForTags={searchForTags}
                        resetTagSearch={resetTagSearch}
                        saveMonitoringQuery={saveMonitoringQuery}
                        loadResultFile={loadResultFile}
                        loadHistoryQueryResult={loadHistoryQueryResult}
                        exportExploreResultToCSV={exportExploreResultToCSV}
                        exportExploreResultToJSON={exportExploreResultToJSON}
                        exportSpoofingToCSV={exportSpoofingToCSV}
                        exportSpoofingToJSON={exportSpoofingToJSON}
                        exportSingleIOC={exportSingleIOC}
                        resetEnrichment={resetEnrichment}
                        loadMySubscriptionPlan={loadMySubscriptionPlan}
                        saveBreadCrumbs={saveBreadCrumbs}
                        queryNameInTXTRecipe={queryNameInTXTRecipe}
                        user={user}
                        //sources
                        exploreFilters={exploreFilters}
                        exploreSorting={exploreSorting}
                        status={status}
                        scoreDetails={scoreDetails}
                        mergeAPIEnrichment={mergeAPIEnrichment}
                        mergeAPIscoreDetails={mergeAPIscoreDetails}
                        exploreAPIscoreDetails={exploreAPIscoreDetails}
                        mergeAPIData={mergeAPIData}
                        exploreAPIANYIPscoreDetails={
                          exploreAPIANYIPscoreDetails
                        }
                        exploreAPIANYIPJobID={exploreAPIANYIPJobID}
                        exploreAPIDensityDetails={exploreAPIDensityDetails}
                        exploreAPIDensityStatus={exploreAPIDensityStatus}
                        exploreAPIwhoisDetails={exploreAPIwhoisDetails}
                        infraTagStatus={infraTagStatus}
                        domainInfraTags={domainInfraTags}
                        whoisStatus={whoisStatus}
                        IPEditableFeeds={IPEditableFeeds}
                        IPEditableFeedsStatus={IPEditableFeedsStatus}
                        DomainEditableFeeds={DomainEditableFeeds}
                        DomainEditableFeedsStatus={DomainEditableFeedsStatus}
                        URLEditableFeeds={URLEditableFeeds}
                        URLEditableFeedsStatus={URLEditableFeedsStatus}
                        foundTags={foundTags}
                        searchStatus={searchStatus}
                        riskScoreStatus={riskScoreStatus}
                        exploreRiskScores={exploreRiskScores}
                        exploreASNStatus={exploreASNStatus}
                        exploreASNDetails={exploreASNDetails}
                        breadcrumbs={breadcrumbs}
                        loadBrandImpersonationRecipeResults={
                          loadBrandImpersonationRecipeResults
                        }
                        websocketConnection={props?.websocketConnection}
                      />
                    ) : (
                      <div className={styles.empty_state}>
                        <NoDataIcon
                          style={{ fontSize: 32, marginTop: '8px' }}
                        />
                        <Title level={4}>Query didn't run</Title>

                        <Text>
                          For the results you need to fill out the query form
                          and click Search.
                        </Text>
                      </div>
                    )}
                  </div>
                  {/* </Col> */}
                  {/* </Row> */}
                </Panel>
              </Collapse>
              {/* </Col> */}
            </div>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeSpoofing}
      />
      <DeleteRecipeModal
        isDeleteModalVisible={isDeleteModalVisible}
        handleOk={handleDeleteRecipe}
        handleCancel={handleDeleteCancel}
        loadedRecipe={exploreRecipeSpoofing}
      />
      {renderPane()}

      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid') ? props.recipeStatusSpoofing : STATUS.LOADED
        }
      />
    </>
  );
}

export default Spoofing;
